import Navbar from "../components/Navbar";

export default function Implementation() {
  const steps = [
    {
      title: "आंकड़ा संकलन",
      desc: "MOIC एवं CDPO के द्वारा गत माह संस्थागत प्रसव से जन्म लेने वाली कन्या शिशुओं का आंकड़ा संकलन",
    },

    {
      title: "आवेदन हस्तांतरण",
      desc: "आंकड़ा संकलन पश्चात योजनाओं के लाभ हेतु MOIC एवं CDPO द्वारा सभी आवेदन BDO को हस्तगत करना",
    },

    {
      title: "समन्वय बैठक",
      desc: "प्रखंड विकास पदाधिकारी सह नोडल पदाधिकारी की अध्यक्षता में प्रत्येक माह के प्रथम सप्ताह में सभी संबंधित प्रखंड स्तरीय पदाधिकारियों के साथ समन्वय बैठक",
    },

    {
      title: "लाभ प्रक्रिया",
      desc: "लाभान्वित किये जाने वाले कन्या शिशुओं एवं उनके परिवार को तय योजनाओं के लाभ दिलाने हेतु संबंधित विभाग के पदाधिकारी प्रत्येक माह के 10 तारीख तक उनके योजनाओं से आच्छादित किये जाने हेतु संबंधित पात्र लाभार्थियों से आवेदन प्राप्त कर लाभ हेतु सभी आवश्यक प्रक्रिया पूर्ण अथवा प्रारम्भ करना",
    },

    {
      title: "बेटी जन्मोत्सव कार्यक्रम",
      desc: "सभी प्रखंडों में प्रत्येक माह के तृतीय गुरुवार को प्रखंड मुख्यालय या प्रखंड विकास पदाधिकारी द्वारा चयनित किसी एक स्थान पर गत माह में संस्थागत प्रसव से जन्म लेने वाली सभी नवजात कन्या शिशुओं एवं उनके परिवार के सम्मान में बेटी जन्मोत्सव – कन्या रत्न सम्मान कार्यक्रम का आयोजन",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      <Navbar />

      <div className="max-w-6xl mx-auto p-10">
        <h1 className="text-3xl font-bold text-center text-purple-700 mb-10">
          क्रियान्वयन प्रक्रिया
        </h1>

        <div className="relative border-l-4 border-green-500 pl-10">
          {steps.map((step, index) => (
            <div key={index} className="mb-10 relative">
              {/* Step Circle */}

              <div className="absolute -left-6 top-1 bg-green-600 text-white w-10 h-10 rounded-full flex items-center justify-center font-bold">
                {index + 1}
              </div>

              {/* Step Box */}

              <div className="bg-white shadow rounded p-5">
                <h3 className="text-lg font-bold text-orange-700 mb-2">
                  {step.title}
                </h3>

                <p className="text-gray-700">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
        {/* IMPLEMENTATION OFFICERS */}

        <div className="bg-white shadow rounded p-6 mt-12">
          <h2 className="text-2xl font-bold text-center text-purple-700 mb-6">
            क्रियान्वयन हेतु पदाधिकारी
          </h2>

          <div className="space-y-6 text-lg">
            <div>
              <span className="font-semibold text-purple-700 underline">
                कार्यक्रम हेतु नोडल पदाधिकारी :
              </span>

              <span className="ml-2">प्रखंड विकास पदाधिकारी</span>
            </div>

            <div>
              <span className="font-semibold text-purple-700 underline">
                सहायक नोडल पदाधिकारी :
              </span>

              <span className="ml-2">CDPO & MOIC</span>
            </div>

            <div>
              <span className="font-semibold text-purple-700 underline">
                संयोजक :
              </span>

              <span className="ml-2">
                कार्यक्रम पदाधिकारी (मनरेगा), BHM/HM & BPM (JEEVIKA)
              </span>
            </div>

            <div>
              <span className="font-semibold text-purple-700 underline">
                राशि / सामग्री की उपलब्धता :
              </span>

              <span className="ml-2">
                “बेटी बचाओ-बेटी पढ़ाओ” योजना अंतर्गत महिला एवं बाल विकास निगम,
                भोजपुर द्वारा
              </span>
            </div>
          </div>
        </div>
        {/* GIRL CHILD HONOUR SECTION */}

        <div className="bg-white shadow rounded p-6 mt-12">
          <h2 className="text-2xl font-bold text-center text-purple-700 mb-6">
            कन्या शिशुओं का सम्मान
          </h2>

          <ul className="list-decimal pl-6 space-y-4 text-gray-800 text-lg">
            <li>जिला पदाधिकारी द्वारा बधाई संदेश / शुभकामना संदेश</li>

            <li>कन्या शिशु के नाम से पौधारोपण</li>

            <li>
              नवजात कन्या शिशुओं को बेबी किट (Baby Shampoo 40ml, Baby Massage
              Oil 50ml, Baby Soap 75gm, Baby Lotion 40ml & Baby Powder 50gm)
            </li>

            <li>25 जन कल्याणकारी योजनाओं के लाभ से संबंधित कार्ड</li>

            <li>
              बालिकाओं एवं महिलाओं के उत्थान एवं सशक्तिकरण हेतु केंद्र एवं राज्य
              सरकार द्वारा संचालित विभिन्न योजनाओं के उद्देश्य, पात्रता, लाभ एवं
              योजना से जुड़ने की विधि से संबंधित पम्पलेट
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
